import React, {Component} from 'react';
import Nouislider from "nouislider-react";
import VenueRepository from "../classes/VenueRepository";

class FilterSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {minValue: null, maxValue: null, minLabel: null, maxLabel: null};

    this.venueRepository = new VenueRepository();
    this.venueRepository.getMinMaxField(props.fieldName).then((results) => {
      this.setState({
        minValue: results.minValue,
        maxValue: results.maxValue,
        minLabel: results.minValue,
        maxLabel: results.maxValue
      });
    });

    this.onSlide = this.onSlide.bind(this);
  }

  reload() {
    this.venueRepository.getMinMaxField(this.props.fieldName).then((results) => {
      this.setState({
        minValue: results.minValue,
        maxValue: results.maxValue,
        minLabel: results.minValue,
        maxLabel: results.maxValue
      });
    });
  }

  onSlide(data, props) {
    this.setState({
      minLabel: parseInt(data[0]),
      maxLabel: parseInt(data[1])
    });
  }

  onEnd(data) {
    this.props.onFilter({name: this.props.fieldName, minValue: parseInt(data[0]), maxValue: parseInt(data[1]), label:this.props.title});
  }

  render() {
    if (this.state.minValue == null) {
       return (<div></div>);
     } else {
       return (
         <div className="js-form-item form-item js-form-type-textfield form-item-field-total-capacity-value-min js-form-item-field-total-capacity-value-min">
           <label htmlFor="edit-field-total-capacity-value-min">{this.props.title}</label>
           <Nouislider id="edit-field-total-capacity-value-min"
                       range={{ min: this.state.minValue, max: this.state.maxValue }}
                       step={10}
                       onEnd={(data) => this.onEnd(data, this.props)}
                       start={[this.state.minValue, this.state.maxValue]}
                       onSlide={this.onSlide} connect
           />

           <div className="noUi-label">
             {this.state.minLabel} - {this.state.maxLabel}
           </div>
         </div>
       );
     }
  }
}

export default FilterSlider;
